"use strict";

function toggleShareIconsOptions() {
    const toggle = document.getElementById('toggle-share-icons');
    const options = document.getElementById('share-icons-options');

    if (!toggle || !options) {
        return;
    }

    options.style.display = toggle.checked ? 'block' : 'none';
}

function toggleShareIconPreview() {
    const toggle = document.getElementById('toggle-share-icons');
    const shareIcons = document.querySelectorAll('.zwssgr-share-icon');

    if (!toggle || !shareIcons.length) {
        return;
    }

    shareIcons.forEach((icon) => {
        icon.style.display = toggle.checked ? 'block' : 'none';
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('toggle-share-icons');

    if (!toggle) {
        return;
    }

    toggleShareIconsOptions();
    toggleShareIconPreview();

    toggle.addEventListener('change', function () {
        toggleShareIconsOptions();
        toggleShareIconPreview();
    });
});
